module.exports = __webpack_public_path__ + "static/media/ggsf_logo.de0d12de.jpeg";